import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setUser } from "../../redux/actions/user";
import { API_URL } from "../../config/Config";
import validator from "validator";
import axios from "axios/index";
import { LangValidation } from "../../lang/fa/validation";
import { Row, Col, Alert, Button, FormGroup, Label, CustomInput } from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
import PageLoader from "../loader/PageLoader";

import SaveLoader from "../loader/SaveLoader";
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });

class ProfileInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading1: false,
            activeItemPills: '1',
            fields: {
                firstname: this.props.user.firstName,
                lastname: this.props.user.lastName,
                email: this.props.user.email,
                cell_phone: this.props.user.cellPhone,
                city: this.props.user.city,
                reagent: this.props.user.reagent,
                gender: this.props.user.gender,
                address: this.props.user.address,
                hash_code: this.props.user.hashCode,
                postCode: this.props.user.postCode,
            },
            errors: {},
            hasAlert: false,
        };

    }

    handleValidation(callback) {
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.firstname)) {
            formIsValid = false;
            errors["firstname"] = LangValidation.required;
        } else if (!validator.isLength(fields.firstname, { min: 3, max: undefined })) {
            formIsValid = false;
            errors["firstname"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.lastname)) {
            formIsValid = false;
            errors["lastname"] = LangValidation.required;
        } else if (!validator.isLength(fields.lastname, { min: 3, max: undefined })) {
            formIsValid = false;
            errors["lastname"] = LangValidation.min;
        }
        if (validator.isEmpty(fields.email)) {
            formIsValid = false;
            errors["email"] = LangValidation.required;
        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            errors["email"] = LangValidation.email;
        }
        if (validator.isEmpty(fields.cell_phone)) {
            formIsValid = false;
            errors["cell_phone"] = LangValidation.required;
        } else if (!validator.isNumeric(fields.cell_phone)) {
            formIsValid = false;
            errors["cell_phone"] = LangValidation.numeric;
        }
        this.setState({ errors }, () => {
            return callback(formIsValid)
        });

    }

    handelRadio(event) {
        let fields = this.state.fields;
        let target = event.target;
        fields["gender"] = target.value;
        // console.log(target.value);
        this.setState({
            fields
        })
    }
    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'firstname':
                if (validator.isEmpty(fields.firstname)) {
                    errors["firstname"] = LangValidation.required;
                } else if (!validator.isLength(fields.firstname, { min: 3, max: undefined })) {
                    errors["firstname"] = LangValidation.min;
                }
                break;
            case 'lastname':
                if (validator.isEmpty(fields.lastname)) {
                    errors["lastname"] = LangValidation.required;
                } else if (!validator.isLength(fields.lastname, { min: 3, max: undefined })) {
                    errors["lastname"] = LangValidation.min;
                }
                break;
            case 'email':
                if (validator.isEmpty(fields.email)) {
                    errors["email"] = LangValidation.required;
                } else if (!validator.isEmail(fields.email)) {
                    errors["email"] = LangValidation.email;
                }
                break;
            case 'cell_phone':
                if (validator.isEmpty(fields.cell_phone)) {
                    errors["cell_phone"] = LangValidation.required;
                } else if (!validator.isNumeric(fields.cell_phone)) {
                    errors["cell_phone"] = LangValidation.numeric;
                }
                break;
            default:

        }
        this.setState({
            fields, errors
        });

    }

    static checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }

    handleRequest() {
        const { firstname, lastname, email, cell_phone, reagent, gender, address, postCode } = this.state.fields;
        const data = { firstname, lastname, email, cell_phone, reagent, gender, address, postCode };
        let errors = {};
        this.setState({ loading1: true });
        axios.post(`${API_URL}user-edit?api_token=${this.props.user.apiToken}`, data)
            .then(
                ProfileInfo.checkStatus
            ).then(json => {
                this.props.setUser(json.data);

                toast.success("اطلاعات با موفقیت ذخیره گردید.", {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: true
                });
                this.setState({ loading1: false });
            })
            .catch(error => {
                this.setState({ loading: true });
                const response = error.response;
                if (response === undefined) {
                    console.log(error);
                } else {
                    for (var key in response.data) {
                        if (response.data.hasOwnProperty(key)) {
                            errors[key] = response.data[key];
                        }
                    }
                }
                toast.error("خطایی در هنگام ذخیره سازی اطلاعات رخ داد.", {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: true
                });
                this.setState({ hasAlert: true, errors, loading1: false });
            });
        // this.setState({loading1:false});

    }

    handleSubmit(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const { firstname, lastname, email, cell_phone, city, reagent, gender, address, hash_code, postCode } = this.state.fields;
        const { errors, loading } = this.state;


        return (
            <div className="pt-3">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert ?
                            <Alert color="danger">
                                خطایی در هنگام ثبت اطلاعات رخ داد.
                            </Alert>
                            : ""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8" /> :
                    <form>
                        <Row>
                            <Col md="6" sm="12">
                                <div className="md-form input-group" error="true" >
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-user grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input
                                        type="text"
                                        className={errors["firstname"] ? "form-control is-invalid" : "form-control"}
                                        placeholder="نام"
                                        autoComplete="off"
                                        name="firstname"
                                        value={firstname}
                                        onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["firstname"] ? <div className="invalid-feedback" >{errors["firstname"]}</div> : ""}
                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-user grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input type="text"
                                        placeholder="نام خانوادگی"
                                        className={errors["lastname"] ? "form-control is-invalid" : "form-control"}
                                        autoComplete="off"
                                        name="lastname"
                                        value={lastname}
                                        onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["lastname"] ? <div className="invalid-feedback" >{errors["lastname"]}</div> : ""}
                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-envelope grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input type="email"
                                        placeholder="ایمیل"
                                        className={errors["email"] ? "form-control is-invalid" : "form-control"}
                                        autoComplete="off"
                                        name="email"
                                        value={email}
                                        readOnly={true}
                                        onChange={this.handleChange.bind(this)} />
                                    {errors["email"] ? <div className="invalid-feedback" >{errors["email"]}</div> : ""}

                                </div>

                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-phone grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input type="text"
                                        placeholder="موبایل"
                                        className={errors["cell_phone"] ? "form-control is-invalid" : "form-control"}
                                        autoComplete="off"
                                        name="cell_phone"
                                        value={cell_phone}
                                        readOnly={true}
                                        onChange={this.handleChange.bind(this)} />

                                    {errors["cell_phone"] ? <div className="invalid-feedback" >{errors["cell_phone"]}</div> : ""}

                                </div>
                                <div className="md-form1 input-group">
                                    <Label className="grey-text"><i className="fa fa-map grey-text mt-3" style={{ fontSize: 20 }} />شهر</Label>
                                    <FormGroup inline>
                                        <span className="form-static-value">{city}</span>
                                    </FormGroup>

                                </div>

                            </Col>

                            <Col md="6" sm="12">
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-map-marker grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input type="text"
                                        placeholder="آدرس"
                                        className="form-control"
                                        autoComplete="off"
                                        name="address"
                                        value={address ? address : ""}
                                        onChange={this.handleChange.bind(this)} />

                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-map-pin grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input type="text"
                                        placeholder="کدپستی"
                                        className="form-control"
                                        autoComplete="off"
                                        name="postCode"
                                        value={postCode ? postCode : ""}
                                        onChange={this.handleChange.bind(this)} />
                                </div>
                                <div className="md-form1 input-group">
                                    <Label className="grey-text"><i className="fa fa-male grey-text mt-3" style={{ fontSize: 20 }} /> جنسیت</Label>
                                    <FormGroup check inline>
                                        <CustomInput onClick={this.handelRadio.bind(this)} value="m" type="radio" id="male" name="gender" checked={gender === "m" ? true : false} label="مرد" onChange={() => { }} />
                                    </FormGroup>
                                    <FormGroup check inline>
                                        <CustomInput onClick={this.handelRadio.bind(this)} value="f" type="radio" id="female" name="gender" checked={gender === "f" ? true : false} label="زن" onChange={() => { }} />
                                    </FormGroup>

                                </div>

                                <div className="md-form1 input-group">
                                    <Label className="grey-text"><i className="fa fa-qrcode grey-text mt-3" style={{ fontSize: 20 }} />  کد انحصاری</Label>
                                    <FormGroup inline>
                                        <span className="form-static-value">{hash_code}</span>
                                    </FormGroup>
                                </div>

                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-random grey-text mt-3" style={{ fontSize: 20 }} />
                                    </span>
                                    <input type="text"
                                        className="form-control"
                                        placeholder="کد معرف"
                                        autoComplete="off"
                                        name="reagent"
                                        value={reagent !== "0" ? reagent : ""}
                                        onChange={this.handleChange.bind(this)} />
                                </div>
                                <div className="text-center mt-5">
                                    <Button color="default" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        ثبت<i className="fa fa-paper-plane-o white-text ml-1"></i>
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </form>}
                {this.state.loading1 ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight} /> : ""}
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser: user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileInfo);



// WEBPACK FOOTER //
// ./src/components/user/ProfileInfo.js